import React from "react";
import { Badge } from "./Badge";

type JournalStatus = string;

interface StatusBadgeForJournalsProps {
  status: JournalStatus;
}

export const StatusBadgeForJournals: React.FC<StatusBadgeForJournalsProps> = ({
  status,
}) => {
  // Helper function to get status badge variant
  const getStatusBadgeVariant = (
    status: JournalStatus
  ): "neutral" | "warning" | "success" | "error" => {
    switch (status) {
      case "approved":
      case "ap_ar":
        return "success"; // Approved / Ap/Ar - green
      case "under_review":
        return "warning"; // Under Review - yellow/orange
      case "rejected":
        return "error"; // Rejected - red
      case "save_as_draft":
        return "neutral"; // Save as Draft - neutral
      default:
        return "neutral";
    }
  };

  // Helper function to get badge custom className for text color override
  const getBadgeClassName = (status: JournalStatus): string => {
    switch (status) {
      case "approved":
      case "ap_ar":
        return "[&>span]:!text-success-800"; // Dark green text on light green background
      case "rejected":
        return "[&>span]:!text-error-800"; // Dark red text on light red background
      default:
        return "";
    }
  };

  // Helper function to get status label
  const getStatusLabel = (status: JournalStatus): string => {
    switch (status) {
      case "approved":
        return "Approved";
      case "ap_ar":
        return "Ap/Ar";
      case "under_review":
        return "Under Review";
      case "rejected":
        return "Rejected";
      case "save_as_draft":
        return "Save as Draft";
      default:
        return "Unknown";
    }
  };

  return (
    <Badge
      variant={getStatusBadgeVariant(status)}
      className={getBadgeClassName(status)}
    >
      {getStatusLabel(status)}
    </Badge>
  );
};
